<template>
  <div class="download-wrapper">
    <button v-if="!btnSpinner"
            @click="downloadFiles"
            class="down-load-btn"
            type="button"
            style="border: none; padding: 0; width: 36px;"
            v-tooltip="{ content: 'pdf 다운로드', placement: 'bottom', triggers: ['hover', 'touch'], autoHide: true}"
    >
      <img src="@/assets/images/icon/ico_download.png" alt=""/>
    </button>
    <div v-else class="spinner-container">
      <div class="btn-spinner" style="width: 100%; height: 100%"></div>
    </div>
    <div id="temp-downloadFiles-link" style="visibility: hidden">
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import {apiClient} from "@/services/auth-header";

const btnSpinner = ref(false);

const downloadFiles = async (artWorkUuid) => {
  try {
    btnSpinner.value = true;
    const response = await apiClient.get('/v1/artists/me/portfolio/file-urls');

    if (response.status === 200) {
      const fileUrls = response.data.urls ?? [];
      await downloadAttachments(fileUrls);
    }

  } catch (error) {
    console.error("Error deleting artwork:", error);
  } finally {
    btnSpinner.value = false;
  }
}

async function downloadAttachments(urls) {
  try {

    for (const url of urls) {
      // URL에서 파일명 추출 후 디코딩 처리
      const encodedFileName = url.split('/').pop().split('?')[0];
      const fileName = decodeURIComponent(encodedFileName);

      const fileBlob = await fetch(url).then(res => res.blob());

      const blobUrl = window.URL.createObjectURL(fileBlob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;  // 디코딩된 파일명 할당
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }

  } catch (error) {
    console.error("첨부파일 다운로드 중 오류 발생:", error);
  }
}

defineExpose({
  downloadFiles,
});
</script>

<style scoped>
.download-wrapper {
  display: flex;
  align-items: center;
}

.spinner-container {
  position: relative;
  width: 30px;
  height: 30px;
}

.down-load-btn{
  width: clamp(30px, 3.0vw, 40px);
}
</style>